import React from "react";
import { $Typography } from "us.common/components";
import "./WelcomeScreen.scss";
import { useAuth } from "us.helper/hooks/useAuth";
import { useTranslation } from "react-i18next";

/**
 * WelcomeScreen component for the UniQ Assistant
 *
 * Displays a stylish welcome interface with animated elements,
 * suggested prompts, and quick document action buttons.
 *
 */
const WelcomeScreen = () => {
  const { account } = useAuth();
  const { t } = useTranslation("US.COMMON");

  /**
   * Generates a personalized greeting message based on time of day and user name
   * @param userName - The name of the user
   * @returns A greeting message string
   */
  const getGreetingMessage = (userName?: string): string => {
    const hour = new Date().getHours();
    // Extract first name only
    const firstName = userName?.split(" ")[0] || "User";

    let timeGreeting = "";
    if (hour >= 5 && hour < 12) {
      timeGreeting = t("US.COMMON:UNIQ.GOOD_MORNING"); // "Good morning"
    } else if (hour >= 12 && hour < 17) {
      timeGreeting = t("US.COMMON:UNIQ.GOOD_AFTERNOON"); // "Good afternoon"
    } else if (hour >= 17 && hour < 22) {
      timeGreeting = t("US.COMMON:UNIQ.GOOD_EVENING"); // "Good evening"
    } else {
      timeGreeting = t("US.COMMON:UNIQ.HELLO"); // "Hello"
    }

    return `${timeGreeting} ${firstName}!`;
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <$Typography className="welcome-title">
          {getGreetingMessage(account?.name)}
        </$Typography>
        <$Typography className="welcome-subtitle">
          {t("US.COMMON:UNIQ.WELCOME_MESSAGE")}{" "}
          {/* "Welcome to UniQ Assistant, how may I help you today?" */}
        </$Typography>
      </div>
    </div>
  );
};

export default WelcomeScreen;
